import { render, staticRenderFns } from "./PersonaDocumentoForm.vue?vue&type=template&id=875cb476&scoped=true"
import script from "./PersonaDocumentoForm.vue?vue&type=script&lang=js"
export * from "./PersonaDocumentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875cb476",
  null
  
)

export default component.exports